import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { useStateContext } from "../../../contexts/ContextProvider";
import { postRequest } from "../../../constants/api";
import { ShowTableLelangBulanan } from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { SearchBar, Loader, ButtonModifier } from "../../../components";
import { formatDate } from "../../../constants/helper";
import { Container, Form, Row, Col } from "react-bootstrap";
import { Box, Pagination, Button, ButtonGroup } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useDownloadExcel } from "react-export-table-to-excel";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilLelangBulanan = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);
  const reportTemplateRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];

  const [isFetchError, setIsFetchError] = useState(false);

  // Angsuran
  const [kelompokId, setKelompokId] = useState("");
  const [angsuranKelompokId, setAngsuranKelompokId] = useState("");
  const [noKelompok, setNoKelompok] = useState("");
  const [no, setNo] = useState("");
  const [tglJatuhTempo, setTglJatuhTempo] = useState("");
  const [tglLelang, setTglLelang] = useState("");
  const [minimalLelang, setMinimalLelang] = useState("");
  const [nominal, setNominal] = useState("");

  const [lelangBulanans, setLelangBulanans] = useState([]);

  const [lelangBulananReport, setLelangBulananReport] = useState([]);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [previewExcel, setPreviewExcel] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    getLelangBulananById();
  }, [id]);

  useEffect(() => {
    getLelangBulanans();
  }, [page, searchTerm]);

  const getLelangBulanans = async () => {
    setLoading(true);
    try {
      const response = await postRequest(
        `/lelangBulanansPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {},
        navigate,
        dispatch,
      );
      setQuery(searchTerm);
      setLelangBulanans(response.data.lelangBulanans);
      setPage(response.data.page);
      setPages(response.data.totalPage);
      setRows(response.data.totalRows);
    } catch (error) {
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getLelangBulananReportData = async () => {
    try {
      const response = await postRequest(
        `/lelangBulanans`,
        {},
        navigate,
        dispatch,
      );
      setLelangBulananReport(response.data);
    } catch (error) {
      setIsFetchError(true);
    }
  };

  const getLelangBulananById = async () => {
    setLoading(true);
    if (id) {
      const response = await postRequest(
        `/lelangBulanans/${id}`,
        {},
        navigate,
        dispatch,
      );

      // Angsuran
      setKelompokId(response.data.angsurankelompok.kelompok.id);
      setAngsuranKelompokId(response.data.angsurankelompok.id);
      setNoKelompok(response.data.angsurankelompok.kelompok.noKelompok);
      setNo(response.data.angsurankelompok.no);
      setTglJatuhTempo(new Date(response.data.angsurankelompok.tglJatuhTempo));
      setTglLelang(new Date(response.data.tglLelang));
      setMinimalLelang(response.data.minimalLelang);
      setNominal(response.data.nominal);
    }
    setLoading(false);
  };

  const deleteLelangBulanan = async (id) => {
    setLoading(true);
    try {
      await postRequest(
        `/deleteLelangBulanan/${id}`,
        { kelompokId, angsuranKelompokId, nominal },
        navigate,
        dispatch,
      );
      getLelangBulanans();

      // Angsuran
      setAngsuranKelompokId("");
      setNoKelompok("");
      setNo("");
      setTglJatuhTempo("");
      setTglLelang("");
      setMinimalLelang("");
      setNominal("");

      navigate("/lelangBulanan");
    } catch (error) {
      if (error.response.data.message.includes("foreign key")) {
        alert(`${no} tidak bisa dihapus!`);
      }
    }
    setLoading(false);
  };

  const downloadPdf = () => {
    var date = new Date();
    var current_date =
      date.getDate().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      "-" +
      (date.getMonth() + 1).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      "-" +
      date.getFullYear();
    var current_time =
      date.getHours().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getMinutes().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getSeconds().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text(`${setting.namaPerusahaan} - ${setting.kotaPerusahaan}`, 15, 10);
    doc.text(`${setting.alamatPerusahaan}`, 15, 15);
    doc.setFontSize(16);
    doc.text(`Daftar Lelang Bulanan`, 85, 30);
    doc.setFontSize(10);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290,
    );
    doc.autoTable({
      html: "#table",
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 45,
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
    });
    window.open(URL.createObjectURL(doc.output("blob")));
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Lelang Bulanan",
    sheet: "Setoran Bulanan",
  });

  const handleGeneratePdf = () => {
    const doc = new jsPDF({
      format: "a4",
      unit: "px",
    });
    doc.html(reportTemplateRef.current, {
      async callback(doc) {
        await window.open(URL.createObjectURL(doc.output("blob")));
      },
      html2canvas: { scale: 0.44 },
    });
  };

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Container>
      {id && (
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => {
            navigate("/lelangBulanan");
          }}
          sx={{ marginRight: 2 }}
        >
          {"< Kembali"}
        </Button>
      )}
      <h3>Lelang</h3>
      <h5 style={{ fontWeight: 400 }}>Daftar Lelang Bulanan</h5>
      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            color="primary"
            startIcon={<SearchIcon />}
            onClick={() => {
              setPreviewPdf(!previewPdf);
              getLelangBulananReportData();
              setPreviewExcel(false);
            }}
          >
            PDF
          </Button>
          <Button
            color="secondary"
            startIcon={<SearchIcon />}
            onClick={() => {
              setPreviewExcel(!previewExcel);
              getLelangBulananReportData();
              setPreviewPdf(false);
            }}
          >
            Excel
          </Button>
        </ButtonGroup>
      </Box>
      {previewPdf && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={() => downloadPdf()}
          >
            CETAK
          </Button>
          <table class="table" id="table">
            <thead>
              <tr>
                <th>No</th>
                <th>Tgl. Jatuh Tempo</th>
                <th>Nominal</th>
              </tr>
            </thead>
            <tbody>
              {lelangBulananReport.map((penerimaan, index) => {
                return (
                  <tr key={penerimaan.id}>
                    <td>{index + 1}</td>
                    <td>
                      {formatDate(penerimaan.angsurankelompok.tglJatuhTempo)}
                    </td>
                    <td>{penerimaan.nominal.toLocaleString("en-US")}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      <div>
        {previewExcel && (
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={onDownload}
          >
            EXCEL
          </Button>
        )}
        <table ref={tableRef}>
          {previewExcel && (
            <tbody>
              <tr>
                <th>No</th>
                <th>Tgl. Jatuh Tempo</th>
                <th>Nominal</th>
              </tr>
              {lelangBulananReport.map((penerimaan, index) => {
                return (
                  <tr key={penerimaan.id}>
                    <td>{index + 1}</td>
                    <td>
                      {formatDate(penerimaan.angsurankelompok.tglJatuhTempo)}
                    </td>
                    <td>{penerimaan.nominal.toLocaleString("en-US")}</td>
                  </tr>
                );
              })}
            </tbody>
          )}
        </table>
      </div>
      {!id && (
        <Box sx={buttonModifierContainer}>
          <ButtonGroup variant="contained">
            <Button
              color="success"
              sx={{ bgcolor: "success.light", textTransform: "none" }}
              startIcon={<AddCircleOutlineIcon />}
              size="small"
              onClick={() => {
                navigate(`/lelangBulanan/tambahLelangBulanan`);
              }}
            >
              Tambah
            </Button>
          </ButtonGroup>
        </Box>
      )}
      <Box sx={buttonModifierContainer}>
        <ButtonModifier
          id={id}
          kode={id}
          editLink={`/lelangBulanan/${id}/edit`}
          deleteUser={deleteLelangBulanan}
          nameUser={no}
        />
      </Box>
      {id && (
        <Container>
          <hr />
          <Form>
            <Box sx={showDataContainer}>
              <Box sx={showDataWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Kelompok :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={noKelompok} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Angsuran :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={no} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tgl. Jatuh Tempo :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={formatDate(tglJatuhTempo)}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tgl. Lelang :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={formatDate(tglLelang)}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Minimal Lelang :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={minimalLelang.toLocaleString("en-US")}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nominal :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={nominal.toLocaleString("en-US")}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[showDataWrapper, secondWrapper]}></Box>
            </Box>
          </Form>
        </Container>
      )}
      <hr />
      {!id && (
        <>
          <Form onSubmit={searchData}>
            <Box sx={searchBarContainer}>
              <SearchBar value={query} setSearchTerm={setQuery} />
              <Button
                variant="contained"
                type="submit"
                color="primary"
                disableElevation
              >
                Cari
              </Button>
            </Box>
          </Form>
          <Box sx={tableContainer}>
            <ShowTableLelangBulanan currentPosts={lelangBulanans} />
          </Box>
          <Box sx={tableContainer}>
            <Pagination
              count={pages}
              page={page + 1}
              onChange={handleChange}
              color="primary"
              size={screenSize <= 600 ? "small" : "large"}
            />
          </Box>
        </>
      )}
    </Container>
  );
};

export default TampilLelangBulanan;

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "12px",
  fontFamily: "sans-serif",
  width: "1000px",
};

const titleCetak = {
  textAlign: "center",
  fontWeight: "bold",
  marginTop: "20px",
};

const noTandaTerimaCetak = {
  textAlign: "center",
  fontWeight: "500",
};

const containerContent = {
  display: "flex",
  marginLeft: "120px",
};

const containerContentRight = {
  display: "flex",
  marginLeft: "460px",
  marginTop: "-20px",
};

const wrapperContent = {
  marginTop: "20px",
  width: "800px",
  fontSize: "15px",
};

const numberContent = {
  marginLeft: "20px",
  width: "100px",
  display: "flex",
  justifyContent: "right",
};

const thirdNumberContent = {
  display: "flex",
  marginLeft: "20px",
  marginTop: "-15px",
};

const totalContainer = {
  display: "flex",
  marginLeft: "20px",
  marginTop: "-15px",
};

const totalText = {
  marginLeft: "110px",
  marginRight: "46px",
  fontWeight: "bold",
};

const totalWrapper = {
  display: "flex",
  height: "20px",
  borderBottom: "1px solid black",
};

const totalNumber = {
  marginLeft: "20px",
  width: "100px",
  display: "flex",
  justifyContent: "right",
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};
